/*
 * the NotificationsService class handles notification requests
 * http://stackoverflow.com/questions/34755350/using-http-rest-apis-with-angular-2/34758630#34758630 (see accepted answer by Pardeep Jain)
 * http://stackoverflow.com/questions/37290672/passing-parameters-in-http-get-using-angular-2 (see accepted answer by Pardeep Jain)
 * https://angular.io/docs/ts/latest/guide/server-communication.html#!#error-handling
 * by ole fjarestad
 */

import { Injectable } from '@angular/core';
import { Http, Headers, Request, RequestOptions, RequestMethod, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { api } from './api';


@Injectable()
export class NotificationsService {

	private notificationsUrl: string = api.base + '/ajax-notifications/get-latest';

	constructor(private http: Http) { }

	// private getHeaders() {
	private getRequestOptions( options ) {
		let headers = new Headers();
		headers.append( 'Accept', 'application/json' );
		options.headers = headers;
		let requestOptions = new RequestOptions(options);
		return requestOptions;
	}

	private handleError(error: Response | any) {
		return Observable.throw(error);
	}

	getLatest(): Observable<[{}]> {
		var requestOptions = {
			withCredentials: true,
			method: RequestMethod.Get,
			url: this.notificationsUrl,
		}

		let notifications$ = this.http
								.request( new Request(this.getRequestOptions(requestOptions)) )
								// .do( (res: Response) => console.log( res ) )
								.map( (res: Response) => res.json().data )
								// .do( (res: Response) => console.log( res ) )
								.catch( this.handleError );

		return notifications$;
	}
	
}



// WEBPACK FOOTER //
// ./src/app/notifications.service.ts